let _ = require('lodash');
let computed = require('../computed/order');
let computedPrice = require('../computed/order/price');
let moment = require('moment');
let treeHelpers = require('../../helpers/tree');
let { recalculateFlags } = require('../../actions/custom-order/cities');
let additionalParameters = require('./additional-parameters');
let { thenWithErrorHandling } = require('../../helpers/errorHandler');
const { saveAs } = require('file-saver');

module.exports = {
    setComputedFields (args, state) {
        computedPrice.datepicker(state);
        computedPrice.firmsPluralized(state);
        computedPrice.isBasicPriceAnyDiscount(state);
        computed.setCitiesComputes(state);
        computed.setBranchesComputes(state);
        computed.setRubricsComputes(state);
        computed.setLegalEntitiesComputes(state);
        computed.setPurposesComputes(state);
        computed.setMapClassesComputes(state);
        computed.setPaymentTypesComputes(state);
        computed.setNumberOfEmployeesComputes(state);
        computed.computeDataChangeTooltipState(state);
        computed.computeIsExportColumnChecked(state, 'LegalForm');
        computed.computeIsExportColumnChecked(state, 'Purpose');
        computed.computeIsExportColumnChecked(state, 'PaymentTypes');
        computed.computeRubricsState(state);
        computed.formatExportColumnsOptional(state);
        computed.formatExportColumnsOptionalOrder(state);
        computed.formatExportColumnsBasic(state);
        computed.formatExportColumnsBasicOrder(state);
        computed.setExportColumnAlwaysTrueForBasicColumnsCheckbox(state);
        computed.calculateOptionalExportColumnsValue(state);
        computed.isShowGreeder(state);
        computed.isOfflineOrder(state);
        computed.isGosResSourceSelected(state);
        computed.computeRubricsRecognizedInputValue(state);
        computed.computeRubricsUnrecognizedInputValue(state);
        computed.computeIsAnyUnrecognizedRubrics(state);
        computed.computeCitiesRecognizedInputValue(state);
        computed.computeCitiesUnrecognizedInputValue(state);
        computed.computeIsAnyUnrecognizedCities(state);
    },

    setStatisticComputed (args, state) {
        computed.setStatisticComputes(state);
    },

    getAvailableParameters (args, state, output, { context, locator }) {
        let api = locator.resolve('api');
        let request = api.getAvailableParameters(context, locator, {});
        request
            .then((response) => {
                let code = _.get(response, 'status.code');

                if (code !== 200) {
                    output.error({ error: code });
                    return;
                }
                let availableParameters = _.get(response, 'content');
                output.success({ availableParameters });
            })
            .catch((error) => output.error({ error }));
    },

    setAvailableParameters ({ availableParameters }, state) {
        // предполагается, что api всегда отдает корректные данны:
        // 1) три дерева cities, rubrics, legalEntities
        // 2) каждое дерево как минимум содержит 0 узел
        state.set(['order', 'originalParameters'], availableParameters);
    },

    restoreState ({ selectedParameters }, state) {
        let rubrics = _.get(selectedParameters, 'rubrics', []);
        let cities = _.get(selectedParameters, 'cities', []);
        let branches = _.get(selectedParameters, 'branches', []);
        let legalEntities = _.get(selectedParameters, 'legalEntities', []);
        let purposes = _.get(selectedParameters, 'purposes', []);
        let mapClasses = _.get(selectedParameters, 'mapClasses', []);
        let paymentTypes = _.get(selectedParameters, 'paymentTypes', []);
        let numberOfEmployees = _.get(selectedParameters, 'numberOfEmployees', []);
        let numberOfFilials = _.get(selectedParameters, 'numberOfFilials', []);
        let selectedExportColumns = _.get(selectedParameters, 'exportColumns', []);
        let selectedGreederColumns = _.get(selectedParameters, 'greederColumns', []);
        let onlyHeadCards = _.get(selectedParameters, 'onlyHeadCards', false);
        let includeArchiveInn = _.get(selectedParameters, 'includeArchiveInn', false);
        let mapFilter = _.get(selectedParameters, 'mapFilter');

        if (state.get(['order', 'originalParameters', 'rubrics'])) {
            treeHelpers.restoreSelectedLeafsState(
                state,
                ['order', 'originalParameters', 'rubrics'],
                ['order', 'rubrics', 'tree', 'selected'], rubrics);
        }

        if (state.get(['order', 'originalParameters', 'cities'])) {
            treeHelpers.restoreSelectedLeafsState(
                state,
                ['order', 'originalParameters', 'cities'],
                ['order', 'cities', 'tree', 'selected'], cities);
            recalculateFlags(state);
        }

        if (state.get(['order', 'originalParameters', 'branches'])) {
            treeHelpers.restoreSelectedLeafsState(
                state,
                ['order', 'originalParameters', 'branches'],
                ['order', 'branches', 'tree', 'selected'], branches);
            if (branches && branches.length > 0) {
                state.set(['order', 'cities', 'tab'], 'branches');
            }
        }

        if (state.get(['order', 'originalParameters', 'legalEntities'])) {
            treeHelpers.restoreSelectedLeafsState(
                state,
                ['order', 'originalParameters', 'legalEntities'],
                ['order', 'addParams', 'legalEntities', 'tree', 'selected'], legalEntities);
        }

        if (state.get(['order', 'originalParameters', 'purposes'])) {
            treeHelpers.restoreSelectedLeafsState(
                state,
                ['order', 'originalParameters', 'purposes'],
                ['order', 'addParams', 'purposes', 'tree', 'selected'], purposes);
        }

        if (state.get(['order', 'originalParameters', 'mapClasses'])) {
            treeHelpers.restoreSelectedLeafsState(
                state,
                ['order', 'originalParameters', 'mapClasses'],
                ['order', 'addParams', 'mapClasses', 'tree', 'selected'], mapClasses);
        }

        if (state.get(['order', 'originalParameters', 'paymentTypes'])) {
            treeHelpers.restoreSelectedLeafsState(
                state,
                ['order', 'originalParameters', 'paymentTypes'],
                ['order', 'addParams', 'paymentTypes', 'tree', 'selected'], paymentTypes);
        }

        if (state.get(['order', 'originalParameters', 'numberOfEmployees'])) {
            treeHelpers.restoreSelectedLeafsState(
                state,
                ['order', 'originalParameters', 'numberOfEmployees'],
                ['order', 'addParams', 'numberOfEmployees', 'tree', 'selected'], numberOfEmployees);
        }

        function arrayToObj (array) {
            let obj = {};
            for (let i = 0; i < array.length; ++i) {
                obj[i] = array[i];
            }
            return obj;
        }

        state.unset(['order', 'addParams', 'datepicker', 'value']);
        state.unset(['order', 'addParams', 'datepicker2', 'value']);
        additionalParameters.initExportColumnsState({}, state);
        let exportColumns = state.get(['order', 'originalParameters', 'exportColumns', 'columns']);
        _.forEach(exportColumns, function (x) {
            let selected = _.find(selectedExportColumns, { columnId: x.id });
            if (selected) {
                state.set(['order', 'addParams', 'exportColumns', x.id, 'isChecked'], true);
                state.set(['order', 'addParams', 'exportColumns', x.id, 'isMustBeFilled'], selected.isMustBeFilled);
                if (selected.value) {
                    if (x.filterType === 'IsInRangeDatetime') {
                        let from = selected.value[0];
                        let to = selected.value[1];
                        // свдигаем utc на локальное время, datepicker работает с ним
                        state.set(['order', 'addParams', 'datepicker', 'value'],
                            from && moment.utc(from).subtract(moment().utcOffset(), 'm').unix());
                        state.set(['order', 'addParams', 'datepicker2', 'value'],
                            to && moment.utc(to).subtract(moment().utcOffset(), 'm').unix());
                    } else {
                        state.set(['order', 'addParams', 'exportColumns', x.id, 'value'], arrayToObj(selected.value));
                    }
                }
            }
        });

        additionalParameters.initGreederColumns({}, state);
        _.forEach(selectedGreederColumns, function (x) {
            state.set(['order', 'addParams', 'greederColumns', 'value', x, 'isChecked'], true);
        });

        let greederColumns = _.filter(state.get(['order', 'originalParameters', 'greederColumns']),
            (x) => selectedGreederColumns.includes(x.id) && (x.isEgrip || x.isEgrul));
        let isEgripSelected = _.findIndex(greederColumns, { isEgrip: true }) > -1;
        let isEgrulSelected = _.findIndex(greederColumns, { isEgrul: true }) > -1;

        // (странная лабуда) если все выбранные данные есть в ЕГРИП, то отображаем только его
        // если все выбранные данные есть в ЕГРЮЛ, то отображаем только его
        let isAllEgrip = _.every(greederColumns, { isEgrip: true });
        let isAllEgrul = _.every(greederColumns, { isEgrul: true });
        if (isAllEgrip) {
            isEgrulSelected = false;
        } else if (isAllEgrul) {
            isEgripSelected = false;
        }
        state.set(['order', 'addParams', 'greederColumns', 'source', 'egrip', 'isChecked'], isEgripSelected);
        state.set(['order', 'addParams', 'greederColumns', 'source', 'egrul', 'isChecked'], isEgrulSelected);
        additionalParameters.calcEnabledGreederColumns({}, state);

        state.set(['order', 'addParams', 'onlyHeadCards'], onlyHeadCards);
        state.set(['order', 'addParams', 'includeArchiveInn'], includeArchiveInn);

        let filialsOptions = state.get(['order', 'addParams', 'numberOfFilials', 'options']);
        if (filialsOptions) {
            let optionIndex = _.findIndex(filialsOptions, (x) => Number(x.value) === numberOfFilials);
            if (optionIndex > -1) {
                let oldActiveIndex = _.findIndex(filialsOptions, (x) => x.isActive === true);
                if (oldActiveIndex > -1) {
                    state.set(['order', 'addParams', 'numberOfFilials', 'options', oldActiveIndex, 'isActive'], false);
                }
                state.set(['order', 'addParams', 'numberOfFilials', 'options', optionIndex, 'isActive'], true);
            }
        }

        // чтобы карта перерисовалась заполняем и чистим полигон-фильтр
        state.set(['order', 'cities', 'mapFilterInit'], '');
        state.unset(['order', 'cities', 'mapFilterInit']);
        state.unset(['order', 'cities', 'mapFilter']);

        if (mapFilter) {
            state.set(['order', 'cities', 'mapFilterInit'], mapFilter);
            state.set(['order', 'cities', 'tab'], 'map');
        }
    },

    isEditable (args, state, output) {
        let isEditable = state.get(['account', 'orders', 'computed', 'currentOrder', 'isEditable']);

        if (isEditable === true) {
            output.yes();
        } else {
            output.no();
        }
    },

    setFilterValuesChanged (args, state) {
        state.set(['account', 'orders', 'currentOrder', 'filterValuesChanged'], true);
    },

    unsetFilterValuesChanged (args, state) {
        state.unset(['account', 'orders', 'currentOrder', 'filterValuesChanged']);
        state.unset(['account', 'orders', 'currentOrder', 'tooltips', 'showChangesMustBeSavedOrCancelled']);
    },

    isFilterValuesChanged(args, state, output) {
        let isChanged = state.get(['account', 'orders', 'currentOrder', 'filterValuesChanged']);
        if (isChanged) {
            output.yes();
        } else {
            output.no();
        }
    },

    setShouldPersistToLocalStorage (value) {
        return (args, state) => state.set(['order', 'settings', 'shouldPersist'], value);
    },

    uploadTreeInput ({ treeInput, treeId }, state, output, { context, locator }) {
        let orderTypeId = state.get(['order', 'typeId']) || 1;
        let api = locator.resolve('api');
        let request = treeId === 'rubrics' ?
            api.uploadTreeInputRubrics(context, locator, treeInput) :
            api.uploadTreeInputCities(context, locator, treeInput, orderTypeId);

        thenWithErrorHandling(request, (data) => ({
            unrecognized: _.get(data, 'content.unrecognized'),
            recognized: _.get(data, 'content.recognized') }), output);
    },

    selectRubrics ({ recognized }, state) {
        let recognizedNotIgnored = _.map(_.filter(recognized, { isIgnored: false }), 'id');
        treeHelpers.selectLeafs(
            state,
            ['order', 'originalParameters', 'rubrics'],
            ['order', 'rubrics', 'tree', 'selected'], recognizedNotIgnored);
    },

    selectCities ({ recognized }, state) {
        let recognizedNotIgnored = _.map(_.filter(recognized, { isIgnored: false }), 'id');
        treeHelpers.selectLeafs(
            state,
            ['order', 'originalParameters', 'cities'],
            ['order', 'cities', 'tree', 'selected'], recognizedNotIgnored);
    },

    showRubricsRecognitionResult ({ unrecognized, recognized, treeId }, state) {
        if (unrecognized && unrecognized.length > 0) {
            state.set(['order', 'treeUpload', treeId, 'recognizeAll'], false);
            state.set(['order', 'treeUpload', treeId, 'unrecognized'], unrecognized);
        } else {
            state.set(['order', 'treeUpload', treeId, 'recognizeAll'], true);
            state.unset(['order', 'treeUpload', treeId, 'unrecognized']);
        }
        state.set(['order', 'treeUpload', treeId, 'recognized'], recognized);
    },

    downloadRubricsFile (args, state, output, { locator, context }) {
        let API = locator.resolve('api');

        let request = API.downloadRubricsFile(context, locator);
        request.then((response) => {
            if (response.code === 200) {
                let blob = new Blob([response.content], { type: response.contentType });
                saveAs(blob, 'Data.2gis_рубрики.xlsx');
                output.success();
            } else {
                output.error();
            }
        }).catch((error) => output.error({ error }));
    },

    downloadCitiesFile (args, state, output, { locator, context }) {
        let orderTypeId = state.get(['order', 'typeId']) || 1;
        let API = locator.resolve('api');

        let filePostfix = orderTypeId === 2
            ? '(Offline выборка)'
            : orderTypeId === 3
                ? '(Offline адр. план)'
                : '';

        let request = API.downloadCitiesFile(context, locator, orderTypeId);
        request.then((response) => {
            if (response.code === 200) {
                let blob = new Blob([response.content], { type: response.contentType });
                saveAs(blob, `Data.2gis_города${filePostfix}.xlsx`);
                output.success();
            } else {
                output.error();
            }
        }).catch((error) => output.error({ error }));
    },

    switchTabTransition({ tabId }, state, output) {
        let currentTab = state.get(['order', 'cities', 'tab']) || 'default';
        if (currentTab === 'branches' && tabId === 'default') {
            output.branchesToDefault();
        } else if (currentTab === 'default' && tabId === 'branches') {
            output.defaultToBranches();
        } else {
            output.default();
        }
    },

    isTabSelected(tabId) {
        return function (args, state, output) {
            let currentTab = state.get(['order', 'cities', 'tab']) || 'default';
            if (tabId === currentTab) {
                output.yes();
            } else {
                output.no();
            }
        }
    }
};



// WEBPACK FOOTER //
// ./actions/custom-order/index.js